let giftModal = document.querySelector(".gift-card_modal");
let giftBackground = giftModal.querySelector(".gift-card_background");
let giftWrap = giftModal.querySelector(".gift-card_wrap");
let giftClose = giftModal.querySelector(".close-button");
let openGiftButton = document.querySelectorAll("[element='openForm']");

let giftAnimation = gsap.timeline({ paused: true });

giftAnimation
  .set(giftModal, { display: "flex" })
  .from(giftBackground, {
    backgroundColor: "rgba(0, 0, 0, 0)",
    duration: 0.25,
    ease: "power1.inOut",
  })
  .from(
    giftWrap,
    { opacity: 0, y: "2rem", duration: 0.25, ease: "power1.inout" },
    "<"
  );

openGiftButton.forEach((el) => {
  el.addEventListener("click", () => {
    giftAnimation.play();
    document.querySelector("body").style.overflow = "hidden";
  });
});

giftBackground.addEventListener("click", () => {
  giftAnimation.reverse();
  document.querySelector("body").style.overflow = "auto";
});

giftClose.addEventListener("click", () => {
  giftAnimation.reverse();
  document.querySelector("body").style.overflow = "auto";
});
